import { Button } from "@/components/button";
import { FONT, RADIUS } from "@/styles/common";
import { Box, Center, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

interface CustomWrapperProps {
    isSubMenu: boolean;
}

export const CustomWrapper = styled(Center)<CustomWrapperProps>`
    position: ${({ isSubMenu }) => (isSubMenu ? "absolute" : "relative")};

    & .sub_menu_container {
        @media (max-width: ${({ theme }) => theme.MEDIA.laptop}) {
            display: none;
        }
    }
`;

export const CustomCenter = styled(Center)`
    color: ${({ theme }) => theme.COLOR.white};

    & .dayNight {
        color: ${({ theme }) => theme.COLOR.black};
        background: ${({ theme }) => theme.COLOR.white};
        border: none;
        ${RADIUS(2)}
    }
`;

export const CustomBox = styled(Box)`
    padding: 12px 80px;
    border-left: 1px dotted white;

    @media (max-width: ${({ theme }) => theme.MEDIA.tablet}) {
        display: none;
    }
`;

export const CustomButton = styled(Button)`
    color: ${({ theme }) => theme.COLOR.white};
    border: 1px solid ${({ theme }) => theme.COLOR.white};
`;

export const CustomText = styled(Text)`
    ${FONT("cormorant", 20, 700)}
`;

export const CustomSubText = styled(Text)`
    ${FONT("cormorant", 14, 300)}
`;
